import {types as t} from 'mobx-state-tree';

export const MarkBold = t.model('MarkBold', {
  uuid: t.string,
  bold: t.optional(t.boolean, false),
});

